import React, { useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import toast from 'react-hot-toast';
import api from '../../utils/api';

export default function Contacto() {
  const [form, setForm] = useState({ nombre:'', email:'', telefono:'', mensaje:'' });
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    if (!form.nombre || !form.email || !form.mensaje) return toast.error('Completa los campos requeridos');
    setEnviando(true);
    try {
      await api.post('/config/contacto', form);
      toast.success('Mensaje enviado! Te responderemos pronto 🌿');
      setForm({ nombre:'', email:'', telefono:'', mensaje:'' });
    } catch { toast.error('Error al enviar mensaje. Escríbenos por WhatsApp'); }
    finally { setEnviando(false); }
  };

  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Contacto' }]} />
      <div style={{ maxWidth:960, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:42, color:'var(--forest)', marginBottom:8 }}>Contacto</h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:48 }} />
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:48 }}>
          <div>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, color:'var(--forest)', marginBottom:24 }}>Envianos un mensaje</h2>
            <form onSubmit={enviar}>
              {[
                { key:'nombre', label:'Nombre completo *', ph:'Maria Garcia', type:'text' },
                { key:'email', label:'Correo electronico *', ph:'maria@email.com', type:'email' },
                { key:'telefono', label:'Telefono / WhatsApp', ph:'+57 300...', type:'tel' },
              ].map(f => (
                <div key={f.key} className="form-group">
                  <label className="form-label">{f.label}</label>
                  <input className="form-input" type={f.type} placeholder={f.ph} value={form[f.key]} onChange={e=>setForm(x=>({...x,[f.key]:e.target.value}))} />
                </div>
              ))}
              <div className="form-group">
                <label className="form-label">Mensaje *</label>
                <textarea className="form-input" rows={5} placeholder="Como podemos ayudarte?" value={form.mensaje} onChange={e=>setForm(x=>({...x,mensaje:e.target.value}))} style={{ resize:'vertical' }} />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width:'100%', padding:14, fontSize:15, background:'#9FBE6A', color:'#1C3A1E' }} disabled={enviando}>
                {enviando ? 'Enviando...' : 'Enviar mensaje'}
              </button>
            </form>
          </div>
          <div>
            <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, color:'var(--forest)', marginBottom:24 }}>Informacion de contacto</h2>
            {[
              { icon:'📍', titulo:'Ubicacion', info:'Pasto, Narino, Colombia' },
              { icon:'✉️', titulo:'Email', info:'contacto@wawitaeco.com' },
              { icon:'💬', titulo:'WhatsApp', info:'+57 311 340 7979' },
              { icon:'📷', titulo:'Instagram', info:'@wawitaeco' },
              { icon:'📘', titulo:'Facebook', info:'/wawitaecologico1' },
            ].map(c => (
              <div key={c.titulo} style={{ display:'flex', gap:16, alignItems:'flex-start', marginBottom:20, padding:'16px 20px', background:'#fff', borderRadius:12, boxShadow:'var(--shadow-xs)' }}>
                <span style={{ fontSize:24, flexShrink:0 }}>{c.icon}</span>
                <div>
                  <div style={{ fontWeight:700, color:'var(--forest)', fontSize:14, marginBottom:4 }}>{c.titulo}</div>
                  <div style={{ fontSize:14, color:'var(--ink-light)' }}>{c.info}</div>
                </div>
              </div>
            ))}
            <a href="https://wa.me/573113407979" target="_blank" rel="noreferrer" style={{ display:'block', textAlign:'center', padding:'14px', background:'#25D366', color:'#fff', borderRadius:12, fontWeight:700, textDecoration:'none', fontSize:15, marginTop:8 }}>
              Chatear por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
